import Vue from 'vue'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

function bottomOffset () {
  const empty = document.createElement('div')
  empty.style = 'height:100vh;width:0;position:absolute;'
  document.body.appendChild(empty)

  const el = document.documentElement
  const wh = empty.clientHeight
  const vh = document.scrollingElement.clientHeight

  const diff = wh - vh

  el.style.setProperty(`--offset`, `${208 + diff}px`)

  empty.remove()
}

bottomOffset()
